import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, Menu, X, Lock } from "lucide-react";

const LINKS = [
  { label: "Início", to: "/" },
  { label: "Energia Solar", to: "/energia-solar" },
  { label: "Carregadores", to: "/carregadores" },
  { label: "Soluções", to: "/solucoes" },
  { label: "Projetos e Instalação", to: "/projeto-instalacao" },
  { label: "Plataforma", to: "/plataforma" },
  { label: "Sobre nós", to: "/sobre" },
  { label: "Contato", to: "/contato" },
];

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const linkCls = ({ isActive }) =>
    `text-[13px] font-semibold tracking-wide transition-colors duration-300 whitespace-nowrap ${
      isActive ? "text-amber-500" : "text-slate-600 hover:text-[#0B192C]"
    }`;

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-200/70"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[76px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="site-logo">
          <img
            src="/logo-hb-solar.png"
            alt="HB Solar — Soluções Sustentáveis"
            className="h-11 w-auto rounded-lg"
          />
          <span className="hidden sm:flex items-center gap-1.5 rounded-full bg-[#0B192C] px-3 py-1.5">
            <Zap className="h-3.5 w-3.5 text-amber-400" />
            <span className="font-display text-[11px] font-extrabold uppercase tracking-[0.18em] text-white">
              HB Charger
            </span>
          </span>
        </Link>

        <nav className="hidden xl:flex items-center gap-6" data-testid="main-navigation">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkCls} end={l.to === "/"}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            data-testid="header-simulate-button"
            to="/simule"
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-amber-400 hover:bg-amber-300 text-[#0B192C] text-sm font-extrabold px-5 py-2.5 transition-colors duration-300 shadow-[0_0_24px_rgba(245,158,11,0.3)]"
          >
            Simule seu projeto
          </Link>
          <Link
            data-testid="header-admin-link"
            to="/admin/login"
            aria-label="Acesso restrito"
            title="Acesso restrito"
            className="hidden md:flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-colors duration-300"
          >
            <Lock className="h-4 w-4" />
          </Link>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            aria-label="Abrir menu"
            className="xl:hidden flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 text-slate-700"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden border-t border-slate-100 bg-white px-5 py-4" data-testid="mobile-menu">
          <nav className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={`rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${
                  pathname === l.to ? "bg-amber-50 text-amber-600" : "text-slate-700 hover:bg-slate-50"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/simule"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-xl bg-amber-400 px-4 py-3 text-center text-sm font-extrabold text-[#0B192C]"
            >
              Simule seu projeto
            </Link>
            <Link
              to="/admin/login"
              onClick={() => setOpen(false)}
              className="rounded-xl px-4 py-3 text-center text-xs font-bold text-slate-400 hover:text-amber-500 transition-colors"
            >
              Acesso restrito
            </Link>
          </nav>
        </div>
      )}
    </motion.header>
  );
};
